module.exports = __webpack_public_path__ + "static/media/PM111.dc76f0bb.png";